module.exports = __webpack_public_path__ + "img/ztjjfa.995ab103.jpg";